import {CSSTransition} from "react-transition-group";

export default function Mask({ visible, onToggle, offsetTop, onClose ,style}) {
  
  const closeHandle = () => {
    if (onToggle) {
      onToggle(false);
    } else {
      onClose();
    }
  };
  
  return (
    <CSSTransition in={visible}
                   classNames="fade"
                   timeout={350}
                   unmountOnExit={true}>
      <div onClick={closeHandle}
           className={'fixed w-[100vw] h-[100vh] left-0 top-0 z-50'}
           style={{
             backgroundColor: 'rgba(0,0,0,.5)',
             marginTop: offsetTop,
             ...style
           }}>
      </div>
    </CSSTransition>
  );
}
